export const testDataForSheets = {
	groupName: 'Test Group',
	groupID: '123456',
	userID: 'www.facebook.com/testUser',
	userName: 'test-user',
	firstName: 'Test',
	lastName: 'User',
	requestDate: '11th June 2021',
	joinedDate: '5 years ago',
	noOfMutualFriends: 10,
	noOfTotalFriends: 10,
	noOfFriendsInGroup: 10,
	noOfCommonGroups: 10,
	noOfOtherGroups: 10,
	noOfTotalGroups: 10,
	extraInformation: 'Extra Information',
	gender: 'male',
	country: 'United States',
	tiers: 'Tier1',
	dateAdded: '30th Jan 1899',
	status: 'Approved',
	question1: 'How are you ?',
	answer1: 'I am fine.',
	question2: 'What is your email ID ?',
	answer2: 'test@user.com',
	question3: 'What is your phone no?',
	answer3: '9999999999',
};

export const sheetTemplateUrl =
	'https://docs.google.com/spreadsheets/d/1uQdNeTs6jE6AFjTx13IqI4PvE-UGVEdtKNpiAQvZyTI/edit#gid=0';
